import React from 'react';
import { cn } from '../../lib/utils';
import { themeClasses } from '../../config/themeClasses';
import { Button } from './button';

function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
}) {
  return (
    <div
      className={cn(themeClasses.appKit.emptyDashed, className)}
      role="status"
    >
      {Icon ? (
        <div className={themeClasses.appKit.emptyIconTile}>
          <Icon className="h-7 w-7" aria-hidden />
        </div>
      ) : null}
      <p className={themeClasses.appKit.sectionTitle}>{title}</p>
      {description ? (
        <p className={cn('mt-1 text-sm text-text-secondary', !Icon && 'mt-0')}>{description}</p>
      ) : null}
      {actionLabel && onAction ? (
        <Button className="mt-4" onClick={onAction} variant="default">
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
}

export { EmptyState };
